export enum ContractOptionsFormFields {
  IsMultiYearContract = 'isMultiYearContract',
}
